<template>
  <div class="full-page" :class="{ 'nav-open': $sidebar.showSidebar }">
    <top-navbar></top-navbar>
    <div class="wrapper wrapper-full-page" @click="toggleSidebar">
      <div
        class="page-header header-filter"
        filter-color="white"
        :style="{ backgroundImage: backgroundImage }"
      >
        <div class="container md-offset">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { mapState } from "vuex";

export default {
  components: { ContentFooter, TopNavbar },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "green",
      backgroundImage:
        // 'url("https://images.sports4me.at/img/bg/28423537_FHD.jpg")',
        'url("https://images.sports4me.at/img/bg/44080589_FHD.jpg")',
      sidebarMini: true,
      sidebarImg: true,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300
    };
  },
  computed: {
    setBgImage() {
      let images = ["/img/bg/44080589_FHD.jpg"];
      return {
        backgroundImage: `url(${images[0]})`
      };
      // let images = {
      //   Login: "",
      //   Register: "./img/register.jpg",
      //   Lock: "./img/lock.jpg"
      // };
      // return {
      //   backgroundImage: `url(${images[this.$route.name]})`
      // };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    }
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    }
  }
};
</script>
<style lang="scss" scoped>
@media (max-width: 960px){
  div.container.md-offset {
    padding-left: 0;
    padding-right: 0;
  }
  div.page-header.header-filter {
    background-position: top left;
  }
}
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
